import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const { FiLoader } = FiIcons;

const LoadingScreen = ({ message = 'Loading…' }) => (
  <div className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center gap-8 relative overflow-hidden page-transition">
    {/* Ambient orbs */}
    <div className="absolute inset-0 pointer-events-none">
      <div className="ambient-orb-pink w-[600px] h-[600px] top-[-10%] right-[-10%] animate-orb-float" />
      <div className="ambient-orb-coral w-[500px] h-[500px] bottom-[-10%] left-[-10%] animate-orb-float" style={{ animationDelay: '2s' }} />
    </div>

    <div className="relative flex flex-col items-center gap-8">
      {/* Logo with enhanced glow */}
      <div className="relative">
        <div className="absolute inset-0 bg-brand-pink/20 blur-3xl rounded-full animate-pulse-glow" />
        <img
          src="https://media-manager-c.questera.ai/greta-media/5fb2f9d5255c375c4c593c40a3604cfd971c9f56c7725c3a05c28f383b843f2c3e4f4687d5d18e728c639d20e7900999/images/aW1hZ2UvcG5n/e291f38d345a3c31aa9db040447e5035.png"
          alt="Vision Direct"
          className="w-20 h-20 object-contain drop-shadow-[0_0_40px_rgba(255,102,204,0.8)] animate-float relative z-10"
        />
      </div>

      {/* Enhanced spinner ring */}
      <div className="relative w-16 h-16">
        {/* Outer ring */}
        <div className="absolute inset-0 rounded-full border-2 border-zinc-800" />
        {/* Spinning gradient ring */}
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-brand-pink border-r-brand-coral animate-spin" />
        {/* Inner glow */}
        <div className="absolute inset-2 rounded-full bg-gradient-to-br from-brand-pink/10 to-brand-coral/10 blur-sm animate-pulse" />
      </div>

      {/* Message with skeleton effect */}
      <div className="flex items-center gap-3">
        <div className="w-2 h-2 rounded-full bg-brand-pink animate-bounce" style={{ animationDelay: '0ms' }} />
        <p className="text-xs font-black tracking-widest text-zinc-500 uppercase skeleton px-4 py-1 rounded-full">{message}</p>
        <div className="w-2 h-2 rounded-full bg-brand-coral animate-bounce" style={{ animationDelay: '150ms' }} />
      </div>
    </div>
  </div>
);

export default LoadingScreen;